// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3yPi9","legacyBtn":"MutateMid_legacyBtn__12b3m"};